export const ADD_EMPLOYEE_START = "ADD_EMPLOYEE_START"
export const ADD_EMPLOYEE_SUCCESS = "ADD_EMPLOYEE_SUCCESS"
export const ADD_EMPLOYEE_FAILURE = "ADD_EMPLOYEE_FAILURE"
export const ADD_EMPLOYEE_RESET = "ADD_EMPLOYEE_RESET"

// to get employee

export const GET_EMPLOYEE_START = "GET_EMPLOYEE_START"
export const GET_EMPLOYEE_SUCCESS = "GET_EMPLOYEE_SUCCESS"
export const GET_EMPLOYEE_FAILURE = "GET_EMPLOYEE_FAILURE"
export const GET_EMPLOYEE_RESET = "GET_EMPLOYEE_RESET"

//view-Employee
export const VIEW_EMPLOYEE_START = "VIEW_EMPLOYEE_START"
export const VIEW_EMPLOYEE_SUCCESS = "VIEW_EMPLOYEE_SUCCESS"
export const VIEW_EMPLOYEE_FAILURE = "VIEW_EMPLOYEE_FAILURE"
export const VIEW_EMPLOYEE_RESET = "VIEW_EMPLOYEE_RESET"

// to delete employee

export const DELETE_EMPLOYEE_START = "DELETE_EMPLOYEE_START"
export const DELETE_EMPLOYEE_SUCCESS = "DELETE_EMPLOYEE_SUCCESS"
export const DELETE_EMPLOYEE_FAILURE = "DELETE_EMPLOYEE_FAILURE"
export const DELETE_EMPLOYEE_RESET = "DELETE_EMPLOYEE_RESET"

// to verify employee

export const VERIFY_EMPLOYEE_START = "VERIFY_EMPLOYEE_START"
export const VERIFY_EMPLOYEE_SUCCESS = "VERIFY_EMPLOYEE_SUCCESS"
export const VERIFY_EMPLOYEE_FAILURE = "VERIFY_EMPLOYEE_FAILURE"
export const VERIFY_EMPLOYEE_RESET = "VERIFY_EMPLOYEE_RESET"

// to Edit employee

export const EDIT_EMPLOYEE_START = "EDIT_EMPLOYEE_START"
export const EDIT_EMPLOYEE_SUCCESS = "EDIT_EMPLOYEE_SUCCESS"
export const EDIT_EMPLOYEE_FAILURE = "EDIT_EMPLOYEE_FAILURE"
export const EDIT_EMPLOYEE_RESET = "EDIT_EMPLOYEE_RESET"

// Get Employee profile

export const GET_EMPLOYEE_PROFILE_START = "GET_EMPLOYEE_PROFILE_START"
export const GET_EMPLOYEE_PROFILE_SUCCESS = "GET_EMPLOYEE_PROFILE_SUCCESS"
export const GET_EMPLOYEE_PROFILE_FAILURE = "GET_EMPLOYEE_PROFILE_FAILURE"
export const GET_EMPLOYEE_PROFILE_RESET = "GET_EMPLOYEE_PROFILE_RESET"

// MY EMPLOYEE

export const MY_EMPLOYEE_START = "MY_EMPLOYEE_START"
export const MY_EMPLOYEE_SUCCESS = "MY_EMPLOYEE_SUCCESS"
export const MY_EMPLOYEE_FAILURE = "MY_EMPLOYEE_FAILURE"
export const MY_EMPLOYEE_RESET = "MY_EMPLOYEE_RESET"


// Transfer All Assests

export const TRANSFER_EMP_ASSETS = "TRANSFER_EMP_ASSETS"
export const TRANSFER_EMP_ASSETS_SUCCESS = "TRANSFER_EMP_ASSETS_SUCCESS"
export const TRANSFER_EMP_ASSETS_FAILED = "TRANSFER_EMP_ASSETS_FAILED"